import {Component, OnInit, Input, Output, EventEmitter, SimpleChanges} from '@angular/core';
import {SupplyTypeService} from "../../../routes/jy-srm/basic-data/srm-supply-type/supply-type/supply-type.service";
import {HttpResponse} from "@angular/common/http";

@Component({
  selector: 'app-supply-select',
  templateUrl: './supply-select.component.html',
  styles: []
})
export class SupplySelectComponent implements OnInit {
  @Input() showBol:boolean;
  // @Input() multiple;//是否多选
  @Output() private selectSupply = new EventEmitter();
  public typeTree:any = [];
  constructor(private supplyTypeService:SupplyTypeService) { }
  //传进来supply对应id集合字符串
  @Input() ids:string;

  ngOnInit() {}

  handleCancel(){
    this.selectSupply.emit();
  }

  handleOk(){
    this.selectSupply.emit(this.supply);
  }

  public supply:any = {};
  selectChange(event){
    if(event.nodes.length > 0){
      this.supply = event.node.origin;
    }else{
      this.supply = null;
    }
  }

  //  展开expand
  nzEvent(event): void {
    if (event.eventName === 'expand') {
      if (event.node.isExpanded) {
        event.node.children = [];
        this.supplyTypeService.getSupplyAll({id:event.node.origin.id}).subscribe((data:any) => {
          if(data[0] && data[0].children && data[0].children.length > 0){
            event.node.addChildren(data[0].children);
          }else{
            event.node.isLeaf = true;
            event.node.addChildren([]);
          }
        },() => {event.node.isLeaf = true;event.node.addChildren([])});
      }
    }
  }

  public loading:boolean = false;
  ngOnChanges(changes: SimpleChanges){
    if(changes.showBol && this.showBol){
      this.supplyName = '';
      this.supplyCode = '';
      this.getSupplyData();
    }
  }

  getSupplyData(){
    let param:any = {
      sort: 'code,ASC'
    };
    if(this.supplyName){
      param.name = this.supplyName;
    }
    if(this.supplyCode){
      param.code = this.supplyCode;
    }
    this.loading = true;
    if(this.ids) {
      this.supplyTypeService.getSupplyAllByIds(this.ids,param).subscribe((data) => {
        this.typeTree = data;
        this.loading = false;
      }, () => this.loading = false, () => this.loading = false);
    }else{
      this.supplyTypeService.getSupplyAll(param).subscribe((data) => {
        this.typeTree = data;
        this.loading = false;
      }, () => this.loading = false, () => this.loading = false);
    }
  }

  public supplyName:string = "";
  public supplyCode:string = "";
  reset(){
    this.supplyName = "";
    this.supplyCode = "";
  }
}
